import {getCurrentYear} from '../../utils/commons'
import AmericanBest10Logo from './logo'
import {americanbest10StylesUS} from './styles'

const baseConfig = {
  domainName: 'americanbest10' as const,
  domainType: 'maga' as const,
  siteName: 'American Best 10',
  logo: <AmericanBest10Logo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/americanbest10.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-VYRRB8E1LR',
    camelCaseUrl: 'AmericanBest10.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | AmericanBest10.com – Trusted Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `Discover the most trusted product picks for Americans at AmericanBest10.com. Our expert reviews highlight gear and gadgets with USA-worthy value.`,
    styles: americanbest10StylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
